// extracted by mini-css-extract-plugin
export default {"message":"ErrorMessagePopup_message__SAloL","container":"ErrorMessagePopup_container__S3t0C"};